"use client";

// The marketing opt-in on every booking and checkout form. Buying or booking
// grants no marketing on its own (drizzle/0024, CLAUDE.md "Marketing consent"),
// so this box is the ONLY way a customer joins the list from these forms.
//
// Always unticked by default: a pre-ticked box is not consent. It sits on the
// booking form rather than the intake — the intake is a health questionnaire,
// only consult clients see it, and it arrives after the details were collected.
//
// `staff` is for forms a staff member fills in on a client's behalf (Quick Book,
// supplier portals): the tick then records that the client agreed in person.

export default function MarketingOptIn({
  checked,
  onChange,
  staff = false,
  light = false,
  className = "",
}: {
  checked: boolean;
  onChange: (checked: boolean) => void;
  staff?: boolean;
  /** White text, for a form sitting on a dark photograph. */
  light?: boolean;
  className?: string;
}) {
  return (
    <label className={`flex items-start gap-2 text-sm ${light ? "text-white/85" : "text-[var(--text-on-light)]"} cursor-pointer ${className}`}>
      <input
        type="checkbox"
        name="marketingOptIn"
        className="accent-[var(--text-brand)] shrink-0 mt-1"
        checked={checked}
        onChange={(e) => onChange(e.target.checked)}
      />
      <span>
        {staff
          ? "Client agreed to receive Niki's newsletter, recipes and offers by email."
          : "Email me Niki's newsletter — recipes and offers. Unsubscribe anytime."}
      </span>
    </label>
  );
}
